import React from 'react';
import AgeGroupItem from './ageGroupItem';
import styles from './curriculum.module.css';
import {AgeGroupActivityItem} from './types';
import CTAButton from "../../../common/v2/CTA-Button/cta-button";

const Curriculum: React.FC = () => {
    const groups: AgeGroupActivityItem[] = [
        {
            group: "Nourrisson",
            description:
                "De 9 à 12 mois, l’enfant apprend à contrôler sa tête, à se retourner et à se mettre à quatre pattes. " +
                "Il commence aussi à découvrir les textures, les couleurs et les gestes simples. " +
                "L’apprentissage est centré sur l’équilibre et le développement de la coordination des membres.",
            activities: [
                "Ramper vers un jouet.",
                "S’asseoir avec appui et passer un jouet d’une main à l’autre.",
                "Peindre avec les doigts, toucher, froisser et déchirer du papier.",
            ],
            extraDescription:
                "De 12 à 18 mois, l’enfant commence à marcher, " +
                "à monter et descendre les escaliers, et aime laisser des traces en manipulant différents objets. " +
                "L’apprentissage est centré sur l’équilibre, la coordination entre la marche et la course, " +
                "l’exploration des matières, le développement du toucher et la coordination des deux mains.",
            extraActivities: [
                "Passer dans un tunnel.",
                "Danser, tourner et taper des mains.",
                "Colorier librement et peindre avec des éponges.",
            ],
        },
        {
            group: "Tout-Petits",
            description:
                "De 18 mois à 3 ans et demi, l’enfant développe la coordination bilatérale et commence à imiter, " +
                "nommer et assembler. L’apprentissage est centré sur la stabilité, le contrôle des mouvements, " +
                "la coordination fine et les premières formes de créativité.",
            activities: [
                "Danser avec des mouvements : lever les bras, taper des pieds, tourner.",
                "Peindre avec des pommes de terre, coller des papiers déchirés par l’enfant lui-même.",
                "Manipuler de la pâte faite maison : faire des empreintes et des boudins.",
            ],
        },
        {
            group: "Préscolaire",
            description:
                "De 3 à 5 ans, l’enfant développe la coordination œil-main et la latéralisation, " +
                "ainsi que son sens de l’invention. L’apprentissage est centré sur le contrôle de son corps, " +
                "l’équilibre, la motricité dynamique, l’autonomie et l’imagination.",
            activities: [
                "Lancer une balle dans un bac, viser et cibler.",
                "Imiter les animaux : marcher comme une vache, sauter comme un lapin.",
                "Réaliser des bricolages : fabrication d’objets, découpage, collage et peinture.",
            ],
        },
    ];

    return (
        <>
            <section className={styles.section_container}>
                <div className={styles.content_wrapper}>
                    <div className={styles.image_container}>
                        <img
                            src="/images/programs/objective.jpg"
                            alt="Espace chaleureux de la garderie"
                            className={styles.image}/>
                    </div>

                    <div className={styles.text_content}>
                        <h2 className={styles.section_title}>
                            {"Curriculum (par groupe d’âge)"}
                        </h2>
                    </div>

                    {groups.map((group, index) => (
                        <AgeGroupItem
                            key={index}
                            group={group.group}
                            description={group.description}
                            activities={group.activities}
                            extraDescription={group.extraDescription}
                            extraActivities={group.extraActivities}/>
                    ))}
                </div>
            </section>
            <CTAButton text={"Obtenir Plus D'information"} href={"/contact"}/></>
    );
};

export default Curriculum;
